import { Device } from "@capacitor/device";

let cachedHardwareId: string | null = null;

export async function getHardwareId(): Promise<string> {
  if (cachedHardwareId) return cachedHardwareId;
  try {
    const info = await Device.getId();
    if (info && info.identifier) {
      cachedHardwareId = info.identifier;
      return cachedHardwareId;
    }
  } catch {
    // Not running on native (web) — fall through to localStorage
  }
  let id = localStorage.getItem("hw_device_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("hw_device_id", id);
  }
  cachedHardwareId = id;
  return cachedHardwareId;
}

export function getDeviceId(): string {
  let id = localStorage.getItem("device_id");
  if (!id) { id = crypto.randomUUID(); localStorage.setItem("device_id", id); }
  return id;
}

export function isNetworkError(err: unknown): boolean {
  if (!navigator.onLine) return true;
  if (err instanceof TypeError && /fetch|network|Failed to fetch/i.test(err.message)) return true;
  return false;
}
